module.exports = __webpack_public_path__ + "img/harrisv.53e61a66.jpg";